import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Stepper.module.scss";
export const Stepper = ({ current, steps, className, }) => {
    return (_jsx("div", { className: cn(styles.stepper, className), "aria-label": "\u0428\u0430\u0433\u0438", children: steps.map((s, i) => {
            const n = i + 1;
            const state = n < current ? "done" : n === current ? "current" : "pending";
            return (_jsxs(React.Fragment, { children: [_jsxs("div", { className: cn(styles.step, state === "done" && styles.done, state === "current" && styles.current), children: [_jsx("span", { className: styles.dot, "aria-hidden": "true", children: n }), _jsx("span", { className: styles.label, children: s.label })] }), i < steps.length - 1 && (_jsx("span", { className: styles.connector, "aria-hidden": "true" }))] }, i));
        }) }));
};
